module.exports = __webpack_public_path__ + "static/img/empty.9309f4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty.png
// module id = OmQY
// module chunks = 27